export type DealerAgreementBlock =
  | { kind: 'p'; text: string }
  | { kind: 'ul'; items: string[] }
  | { kind: 'h3'; text: string };

export type DealerAgreementSection = {
  heading: string;
  blocks: DealerAgreementBlock[];
};

export type DealerAgreementDoc = {
  title: string;
  sections: DealerAgreementSection[];
};

/** 딜러 약정서 본문 (약관 상세 페이지 문서 레이아웃용) */
export const DEALER_AGREEMENT_DOCUMENT: DealerAgreementDoc = {
  title: '딜러회원 가입/전환 약정서 (동의 및 서약)',
  sections: [
    {
      heading: '문서 목적',
      blocks: [
        {
          kind: 'p',
          text: '본 약정서는 주식회사 직트럭(이하 “회사”)의 딜러회원 제도에 가입 또는 전환하는 자(이하 “딜러회원”)가, 딜러회원 서비스 이용에 관해 필요한 사항을 확인·동의·서약하기 위해 작성됩니다.',
        },
        {
          kind: 'p',
          text: '본 약정은 회사의 이용약관/개인정보처리방침/운영정책(검수·노출·연결·수수료 등)과 함께 적용됩니다.',
        },
      ],
    },
    {
      heading: '0. 적용 관계(우선순위)',
      blocks: [
        {
          kind: 'p',
          text: '본 약정과 회사의 이용약관/운영정책이 상충할 경우, 딜러회원 서비스에 관해서는 본 약정이 우선 적용됩니다.',
        },
        {
          kind: 'p',
          text: '본 약정에 정하지 않은 사항은 회사 이용약관/운영정책 및 관계 법령을 따릅니다.',
        },
      ],
    },
    {
      heading: '1. 딜러회원 자격 확인 및 가입 승인',
      blocks: [
        {
          kind: 'p',
          text: '딜러회원은 가입/전환 신청 시 매매사원증 정보 등 회사가 요구하는 자격 확인 자료를 제출해야 합니다.',
        },
        { kind: 'p', text: '회사는 관련 기관/시스템 조회 또는 합리적 방법으로 자격을 확인할 수 있습니다.' },
        {
          kind: 'p',
          text: '회사는 자격 확인 결과에 따라 승인/보류/거절할 수 있으며, 승인 이전에는 딜러회원 서비스를 이용할 수 없습니다.',
        },
        {
          kind: 'p',
          text: '딜러회원은 제출 정보가 항상 최신·진실 임을 보증하며, 변경 시 즉시 수정·통지합니다.',
        },
      ],
    },
    {
      heading: '2. 차량 등록 및 등록 제한',
      blocks: [
        { kind: 'p', text: '딜러회원은 회사 정책에 따라 차량 등록 대수 제한이 없습니다.' },
        {
          kind: 'p',
          text: '단, 회사는 시스템 안정/부정 이용 방지/운영상 필요에 따라 일시적으로 등록 기능을 제한할 수 있습니다.',
        },
        {
          kind: 'p',
          text: '딜러회원은 등록 매물 정보(차량 상태, 사고/수리/침수/주행거리, 압류·저당 등 권리관계, 옵션, 실매물 여부)를 사실대로 기재·증빙해야 합니다.',
        },
        { kind: 'p', text: '위 내용과 사실과 다를 시 즉각 사용정지 처리됩니다.' },
      ],
    },
    {
      heading: '3. 시세/매물 검수 및 노출 원칙',
      blocks: [
        {
          kind: 'p',
          text: '딜러회원 매물은 서비스 신뢰도 제고를 위해 시세 및 매물 검수 후 노출을 원칙으로 합니다.',
        },
        {
          kind: 'ul',
          items: [
            `매물 검수라 함은 회사가 확인 가능한 범위를 말함
             회사는 내부 기준(시장 시세, 유사 매물, 차량 상태, 거래 관행 등)에 따라 아래 조치를 할 수 있습니다.`,
            '노출 보류/거절',
            '정보 수정 요청',
            '가격/정보 재 검증 요청',
            '허위·과장·미끼매물 의심 시 노출 삭제 또는 계정 제한',
            '검수는 거래 성사·품질을 보장하는 것이 아니며, 회사는 법령상 책임이 인정되는 경우를 제외하고 검수 결과로 인한 손해에 책임을 지지 않습니다.',
          ],
        },
      ],
    },
    {
      heading: '4. 문의 응대 및 거래 연결 방식',
      blocks: [
        {
          kind: 'p',
          text: '딜러회원 매물에 대한 문의는 운영 방식에 따라 회사 영업팀/고객센터가 우선 접수하여 안내·연결할 수 있습니다.',
        },
        {
          kind: 'p',
          text: '딜러회원은 회사의 안내에 따라 상담/견적/방문/서류 등 거래 진행에 협조합니다.',
        },
        {
          kind: 'p',
          text: '딜러회원은 회사의 사전 안내 없이 이용자에게 직접 연락하여 회사를 배제하는 방식(회피 거래)으로 거래를 진행하지 않습니다.',
        },
        {
          kind: 'p',
          text: '회사는 이용자 보호 및 분쟁 예방을 위해 필요한 범위에서 상담 내용을 기록·관리할 수 있습니다.',
        },
        { kind: 'p', text: '부정 행각이 확인되면 즉각 사용정지 처리됩니다.' },
      ],
    },
    {
      heading: '5. 수수료 정책(판매 성사 시)',
      blocks: [
        { kind: 'h3', text: '5-1. 기본 수수료' },
        {
          kind: 'p',
          text: '딜러회원은 회사가 제공한 연결/중개/검수/상담/거래지원의 대가로, 거래 성사 시 아래 수수료를 회사에 지급합니다.',
        },
        {
          kind: 'ul',
          items: [
            '중대형 톤수(예: 1톤 이상): 대당 1,000,000원(부가세 별도)',
            '1톤급: 대당 300,000원 (부가세 별도)',
            '그 외 톤수 구간별 수수료는 회사 정책(톤수 갭 반영)에 따라 별도 고지합니다.',
          ],
        },
        { kind: 'h3', text: '5-2. 부과 기준(거래 성사 정의)' },
        {
          kind: 'p',
          text: '수수료 부과 기준은 회사 정책으로 정하며, 동의 시점에 딜러회원에게 고지합니다.',
        },
        { kind: 'ul', items: ['매매계약 체결 및 대금 지급/이전 완료'] },
        { kind: 'h3', text: '5-3. 회피 거래(회사 배제) 금지' },
        {
          kind: 'ul',
          items: [
            '회사 연결로 알게 된 이용자와 회사 개입 없이 거래를 성사시키는 등 회피 거래가 확인되는 경우, 딜러회원은 회사가 정한 수수료를 지급하고 추가 제재(아래 9조)를 받을 수 있습니다.',
          ],
        },
      ],
    },
    {
      heading: '6. 딜러회원 서약',
      blocks: [
        { kind: 'p', text: '딜러회원은 아래 사항을 확인 및 서약합니다.' },
        {
          kind: 'p',
          text: '실매물/정당 권한 보증: 등록 매물은 실재하며, 등록·판매에 필요한 권한이 있고 허위/미끼/중복 매물이 아닙니다.',
        },
        {
          kind: 'p',
          text: '정보 진실성: 차량 상태 및 권리관계(압류·저당·리스/할부·사고/침수·주행거리 조작 등)를 사실대로 고지하며, 허위·과장 표시를 하지 않습니다.',
        },
        {
          kind: 'p',
          text: '법령 준수: 자동차관리법, 표시·광고 관련 법령, 개인정보보호법 등 관계 법령을 스스로 준수하고 회사 정책을 따릅니다.',
        },
        {
          kind: 'ul',
          items: [
            '분쟁 협조: 거래 관련 분쟁(클레임, 환불, 하자, 서류 등) 발생 시 회사 요청에 협조하고 필요한 자료를 신속히 제출합니다.',
          ],
        },
        {
          kind: 'p',
          text: '회사의 법적 피해 방지: 딜러회원의 위법·부당 행위로 회사에 민형사상 분쟁/손해가 발생하지 않도록 하며, 발생 시 아래 배상조항(아래 8조)에 따릅니다.',
        },
      ],
    },
    {
      heading: '7. 개인정보 및 문의자 정보 제공',
      blocks: [
        {
          kind: 'p',
          text: '회사는 매물 문의/상담 및 거래 연결을 위해 딜러회원에게 아래 필요 최소한의 정보를 제공할 수 있습니다.',
        },
        {
          kind: 'ul',
          items: [
            '문의 내용(필요 최소)',
            '관심 매물 식별정보 등',
            '이용자 연락처(전화번호 등)는 제공하지 않으며, 회사 정책에 따라 회사가 우선 소통합니다.',
            '딜러회원은 제공받은 정보를 거래 진행 목적 외 사용하지 않으며, 목적 달성 후 즉시 파기하고, 제3자 제공/유출/마케팅 사용을 금지합니다.',
          ],
        },
      ],
    },
    {
      heading: '8. 위반 시 조치(제재) 및 손해배상/면책',
      blocks: [
        {
          kind: 'p',
          text: '딜러회원이 본 약정/약관/정책을 위반하거나 위반 우려가 있는 경우, 회사는 사전 통지 후 또는 긴급 시 사후 통지로 아래 조치를 할 수 있습니다.',
        },
        {
          kind: 'ul',
          items: [
            '매물 노출 제한/삭제',
            '가격·정보 수정 요청',
            '딜러회원 기능 제한',
            '계정 정지/해지, 재가입 제한',
            '법적 조치',
          ],
        },
        {
          kind: 'p',
          text: '딜러회원의 위반으로 회사가 이용자/제3자로부터 클레임, 민형사상 청구, 행정제재 등을 받거나 비용(조사·소송·변호사비 포함)이 발생한 경우, 딜러회원은 회사에 그 손해를 전액 배상합니다.',
        },
        {
          kind: 'p',
          text: '회사는 딜러회원과 이용자 간 거래의 당사자가 아니며, 법령상 책임이 인정되는 경우를 제외하고 거래로 인한 손해에 책임을 지지 않습니다.',
        },
      ],
    },
    {
      heading: '9. 약정의 효력, 탈퇴, 변경',
      blocks: [
        {
          kind: 'p',
          text: '본 약정은 딜러회원이 동의(체크박스 동의포함)한 시점부터 효력이 발생합니다.',
        },
        {
          kind: 'p',
          text: '딜러회원은 언제든 딜러회원 탈퇴를 신청할 수 있으나, 탈퇴 이전에 성사된 거래에 대한 수수료 및 분쟁 대응 의무는 소멸하지 않습니다.',
        },
        {
          kind: 'p',
          text: '회사는 관련 법령 및 서비스 운영상 필요에 따라 본 약정 및 정책을 변경할 수 있으며, 변경 사항은 사전 고지 후 적용합니다.',
        },
      ],
    },
    {
      heading: '10. 준거법 및 관할',
      blocks: [
        { kind: 'p', text: '본 약정은 대한민국 법을 준거법으로 합니다.' },
        {
          kind: 'p',
          text: '분쟁 발생 시 회사 본점 소재지 관할 법원을 전속 관할로 합니다.',
        },
      ],
    },
  ],
};
